var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-wrap lg:tw-space-x-3 tw-space-y-2 lg:tw-space-y-3 tw-justify-between tw-items-center"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }